var map = {
	"./autocomplete-dropdown/template.hbs": 3993,
	"./mw-audio-options-dropdown/template.hbs": 86261,
	"./mw-badge-hint-popup/template.hbs": 98900,
	"./mw-chat-info-member-dropdown/template.hbs": 81392,
	"./mw-chat-options-dropdown/template.hbs": 75517,
	"./mw-document-options-dropdown/template.hbs": 93184,
	"./mw-emoji-list-popup/template.hbs": 92358,
	"./mw-emoji-name-popup/template.hbs": 41517,
	"./mw-emoji-picker/template.hbs": 37856,
	"./mw-emoji-sender-dropdown/template.hbs": 30062,
	"./mw-file-options-dropdown/template.hbs": 62853,
	"./mw-giphy-picker/template.hbs": 11470,
	"./mw-main-header-chats-dropdown/template.hbs": 21587,
	"./mw-main-header-events-dropdown/template.hbs": 95677,
	"./mw-main-header-groups-dropdown/template.hbs": 84042,
	"./mw-main-header-pages-dropdown/template.hbs": 93334,
	"./mw-main-header-user-dropdown/template.hbs": 14715,
	"./mw-profile-popup/template.hbs": 65610,
	"./mw-simple-emoji-picker/template.hbs": 67530,
	"./mw-sort-dropdown/template.hbs": 10218,
	"./mw-stickers-picker/generate-sticker/template.hbs": 33687,
	"./mw-stickers-picker/template.hbs": 56741,
	"./targets-dropdown/template.hbs": 38665
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43446;
module.exports = webpackAsyncContext;